<template>
  <div class="columns is-centered">
    <div class="column is-7">
      <div class="box is-light">
        <div
          class="columns is-mobile head1 is-gant"
          style=" border-radius: 5px;"
        >
          <div class="column" style="text-align: center;">
            <h1 class="title is-4" style="color: white;">
              <b-icon icon="notebook-multiple"> </b-icon> My Travelers
            </h1>
          </div>
        </div>
        <div>
          <div v-if="loading">
            <b-loading
              :is-full-page="false"
              :active="loading"
              :can-cancel="true"
            ></b-loading>
          </div>
          <div v-else-if="travellers.length > 0">
            <div>{{ loading_status }}</div>
            <div v-if="travellers.length > 0">
              <div class="mb-3">
                Select a traveler from the dropdown list below to see their
                trips:
              </div>

                <b-field label="Find a traveler">
                <b-autocomplete
                  v-model="name"
                  :data="filteredTravellers"
                  placeholder="e.g. John Smith"
                  icon="magnify"
                  clearable
                  field="fullName"
                  @select="option => {selected = option;  searchTrips();}"
                >
                  <template #empty>No results found</template>
                </b-autocomplete>
                </b-field>

              <div id="results">
                <div class="mb-2">{{ trip_loading_status }}</div>
                <div class="trips-list">
                  <div v-for="trip in trips" :key="trip.recordLocator">
                    <TripCard :trip="trip"></TripCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            No travelers found.
          </div>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import TripCard from "@/components/Trip/TripCard.vue";
export default {
  name: "MyTravellers",
  components: {
    TripCard,
  },
  data: function() {
    return {
      travellers: [],
      trips: [],
      loading: true,
      loading_status: "",
      trip_loading_status: "",
      name: "",
      selected: null
    };
  },
  computed: {
    profile() {
      return this.$store.state.travellersAndTrips.profile;
    },
    //Return array of travellers with fullName appended
    travellerList(){
      return this.travellers.map(this.appendFullName);
    },
    //Filter autocomplete matches
    filteredTravellers() {

      return this.travellerList.filter((option) => {
        return option.fullName
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
      });
    }
  },
  methods: {
    //Adds a 'fullName' property to traveller object contains first middle and last name
    appendFullName(x){
      x.fullName = x.firstName + ' ' + (x.middleName? x.middleName[0] + '. ': '') + x.lastName;

      return x
    },
    //Get all authorized travellers for the current user
    async getMyTravellers(id = null) {
      var payload = { contactId: this.profile.id };

      let result = await this.$app.huddleLabsServerCall(
        "profile/my-travelers",
        payload
      );

      //return result data or null on error
      return result.data ?? null;
    },

    //get any/all trips associated with a specific traveller
    async getTripsforTraveller(traveller) {
      let payload = {
        meta: {
          stateful: false,
          sessionKey: null,
          normalizeResponse: true,
        },
        travelerProfileRecordLocator: traveller.amadeusRecordLocator,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips",
        payload
      );

      //return result data or null on error
      return result.data ?? null;
    },

    //get details associated with a specific trip
    async getTripDetails(trip) {
      let payload = {
        meta: {
          stateful: false,
          sessionKey: null,
          normalizeResponse: true,
        },
        recordLocator: trip.recordLocator,
      };
      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/show",
        payload
      );

      //return result data or null on error
      return result.data ?? null;
    },

    async searchTrips($event) {

      let traveller = this.selected;
      console.log(traveller);
      this.trips = [];
      this.trip_loading_status =
        "Searching for trips for " +
        traveller.firstName +
        " " +
        traveller.lastName +
        "...";
      let tripList = await this.getTripsforTraveller(traveller);

      if (tripList) {
        this.trip_loading_status = "Getting trip details...";

        await Promise.all(
          tripList.map(async (t) => {
            //get trip details
            let trip = await this.getTripDetails(t);

            if (trip && trip.tripSummary.status == "active") {
              this.trips.push(trip);
            }
          })
        );

        this.trip_loading_status = this.trips.length + " trip(s) found.";
      } else {
        this.trip_loading_status = "Unable to find trips.";
      }
    },
  },

  async mounted() {
    this.loading_status = "Loading travelers...";
    let travellers = await this.getMyTravellers();

    if (travellers) {
      this.travellers = travellers;
      this.loading_status = "";
    } else {
      this.loading_status = "Failed to load travellers.";
    }

    this.loading = false;
  },
};
</script>

<style scoped>
.button {
  line-height: 1;
}

.bigButton {
  height: 8rem;
}

.medButton {
  height: 3rem;
}

.noPadding {
  padding: 0rem;
}

&:hover {
  transform: scale(1.02, 1.02);
}

.sect {
  background-color: white;
  margin: 10px;
  border-radius: 5px;
}
.g_sect {
  margin: 10px;
  border-radius: 5px;
  text-align: left;
  padding-bottom: 0px;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
.add_margins {
  margin: 10px;
}
.nopad-margins {
  padding-top: 0px;
  margin: 0px;
}
.wdt {
  width: 55%;
  margin: auto;
}

.nobtmpd {
  margin: 0px;
}

.vl {
  /* border-left: 6px solid #E4E8E8; */
  height: 15px;
  margin-bottom: 5px;
}
</style>
